"use strict";

// DOM読み込み完了
document.addEventListener('DOMContentLoaded',  (event) => {
  console.log('DOM Content Loaded.');
  /* 処理内容を記述 */
  var menubtn = document.querySelectorAll('.btn-menu')[0];
  var menu = document.querySelectorAll('.site-menu .menu')[0];

  var spmenubtn = document.getElementsByClassName('toggle-submenu');
  for (let i = 0; i < spmenubtn.length; i++) {
    spmenubtn[i].addEventListener('click', function() {
      spmenubtn[i].classList.toggle('close');
      spmenubtn[i].classList.toggle('open');
    }, false);
  }

  var state = false;
  var scrollpos;
  var menuIcon = document.getElementById('menu-icon');
  var menuBackground = document.getElementById('menu-background');
  var body = document.querySelectorAll('body')[0];

  function scrollStop() {
    if(state == false) {
      scrollpos = window.scrollY;
      body.classList.add('js-fixed');
      // body.style.top = -scrollpos + 'px';
      // $('body').addClass('js-fixed').css({'top': -scrollpos});
      state = true;
    } else {
      body.classList.remove('js-fixed');
      body.style.top = 0;
      // $('body').removeClass('js-fixed').css({'top': 0});
      // window.scrollTo( 0 , scrollpos );
      state = false;
    }
  }

  menuIcon.addEventListener('click',scrollStop);
  menuBackground.addEventListener('click',scrollStop);

 });

// 完全に読み込み完了
window.addEventListener('load', () => {
  console.log('Page Loaded.');
  /* 処理内容を記述 */
});

// スムーススクロール
// スムーススクロール 
// need lib/smooth-scroll/
const scroll = new SmoothScroll('a[href*="#"][data-js-scroll]',{
  speed:200,
  updateURL: false, //URLを書き換えない
});

// ページトップボタン 表示・非表示切り替え
window.addEventListener('scroll', function () {
  const el_pageTopBtn = document.getElementsByClassName('el_pageTopBtn')[0];
  // 画面トップからの距離から画面の高さより小さければ実行する
    if ( window.scrollY > 100 ) {
      el_pageTopBtn.classList.add('js-show');
      el_pageTopBtn.classList.remove('js-hide');
    } else {
      el_pageTopBtn.classList.add('js-hide');
      el_pageTopBtn.classList.remove('js-show');
    }
});

// スクロールバーサイズ調整
const wk_scrollbar_width = window.innerWidth - document.body.clientWidth;
document.documentElement.style.setProperty("--site-scrollbar_width", wk_scrollbar_width + "px")

//任意のタブにURLからリンクするための設定
function GethashID (hashIDName){
	if(hashIDName){
		//タブ設定
		$('.bl_tab li').find('a').each(function() { //タブ内のaタグ全てを取得
			var idName = $(this).attr('href'); //タブ内のaタグのリンク名（例）#lunchの値を取得	
			if(idName == hashIDName){ //リンク元の指定されたURLのハッシュタグ（例）http://example.com/#lunch←この#の値とタブ内のリンク名（例）#lunchが同じかをチェック
				var parentElm = $(this).parent(); //タブ内のaタグの親要素（li）を取得
				$('.bl_tab li').removeClass("is-active"); //タブ内のliについているactiveクラスを取り除き
				$(parentElm).addClass("is-active"); //リンク元の指定されたURLのハッシュタグとタブ内のリンク名が同じであれば、liにactiveクラスを追加
				//表示させるエリア設定
				$(".bl_tab_area").removeClass("is-active"); //もともとついているis-activeクラスを取り除き
				$(hashIDName).addClass("is-active"); //表示させたいエリアのタブリンク名をクリックしたら、表示エリアにis-activeクラスを追加	
			}
		});
	}
}

//タブをクリックしたら
$('.bl_tab a').on('click', function() {
	var idName = $(this).attr('href'); //タブ内のリンク名を取得	
	GethashID (idName);//設定したタブの読み込みと
	return false;//aタグを無効にする
});


// 上記の動きをページが読み込まれたらすぐに動かす
$(window).on('load', function () {
    $('.bl_tab li:first-of-type').addClass("is-active"); //最初のliにactiveクラスを追加
    $('.bl_tab_area:first-of-type').addClass("is-active"); //最初の.areaにis-activeクラスを追加
	var hashName = location.hash; //リンク元の指定されたURLのハッシュタグを取得
	GethashID (hashName);//設定したタブの読み込み
});